import styled from 'styled-components';

export const Container = styled.label`
  cursor: pointer;
  display: flex;

  input[type='radio'] {
    display: none;

    &:hover:not(:checked) {
      & + div {
        border-color: #329bfc;
        background-color: rgba(50, 155, 252, 0.2);
      }
    }

    &:checked {
      & + div {
        background-color: rgba(50, 155, 252);
        border-color: rgba(149, 149, 149, 0.4);

        span {
          display: block;
        }
      }
    }
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-top: 3px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;

  span {
    display: none;
    background-color: #ffffff;
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
`;
